import { RootState } from 'store';

export const availabilitySelector = (state: RootState) => state.availabilities.availability;

export const availabilitiesErrorSelector = (state: RootState) => state.availabilities.error;

export const availabilityForWeekSelector = (state: RootState) => state.availabilities.availabilityForWeek;

export const availabilityForWeekErrorSelector = (state: RootState) => state.availabilities.error;
